import { css } from "@emotion/css";
import { DrawnOctopusIllustration } from "@octopusdeploy/design-system-components";
import { ChevronLeftIcon } from "@octopusdeploy/design-system-icons";
import { text } from "@octopusdeploy/design-system-tokens";
import { logger } from "@octopusdeploy/logging";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { useLocation } from "react-router-dom";
import { repository } from "~/clientInstance";
import InternalLink from "~/components/Navigation/InternalLink/InternalLink";
import { EmptyPage } from "../EmptyPage/EmptyPage";
import InternalRedirect from "../Navigation/InternalRedirect/InternalRedirect";
export const stateFor404Redirect = "404Redirect";
export const RedirectAs404 = () => {
    const location = useLocation();
    return <InternalRedirect to={{ ...location, state: stateFor404Redirect }}/>;
};
export function NotFound() {
    const { pathname } = useLocation();
    React.useEffect(() => {
        logger.info(`The path "{pathname}" did not match any routes`, { pathname });
    }, [pathname]);
    const action = (<InternalLink className={goBackLinkStyles} to={repository.spaceId ? links.spaceRootRedirect.generateUrl({ spaceId: repository.spaceId }) : links.rootRedirect.generateUrl()}>
            <ChevronLeftIcon size={20}/>
            Go back home
        </InternalLink>);
    return (<main>
            <EmptyPage title="Unable to locate page..." image={<DrawnOctopusIllustration />} description={"Our badly drawn octopus suggests retracing your steps."} action={action}/>
        </main>);
}
const goBackLinkStyles = css({
    display: "flex",
    alignItems: "center",
    font: text.body.bold.medium,
});
